import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, saveConsent } from "@/lib/analytics";

/** Banner yüksekliğini CSS değişkenine yazar; böylece içerik bandın arkasında kalmaz. */
function useReserveSpace(ref, active) {
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (!active) {
      root.style.setProperty("--cookie-banner-height", "0px");
      return undefined;
    }
    const apply = () => {
      const h = ref.current?.offsetHeight || 0;
      root.style.setProperty("--cookie-banner-height", `${h}px`);
    };
    apply();
    const observer = new ResizeObserver(apply);
    if (ref.current) observer.observe(ref.current);
    window.addEventListener("orientationchange", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("orientationchange", apply);
      root.style.setProperty("--cookie-banner-height", "0px");
    };
  }, [ref, active]);
}

export const CookieConsent = () => {
  const [consent, setConsent] = useState(getConsent());
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(false);
  const ref = useRef(null);
  const visible = !consent || open;
  useReserveSpace(ref, visible);

  useEffect(() => () => document.documentElement.style.setProperty("--cookie-banner-height", "0px"), []);

  const decide = (values) => {
    saveConsent(values);
    setConsent(values);
    setOpen(false);
    setDetails(false);
  };

  if (!visible)
    return (
      <button
        data-testid="cookie-preferences-btn"
        onClick={() => setOpen(true)}
        style={{
          zIndex: 44,
          bottom: "calc(var(--mobile-bottom-nav-height) + env(safe-area-inset-bottom) + 8px)",
        }}
        className="fixed left-3 rounded-full border border-border bg-card px-3 py-1.5 text-[11px] font-semibold text-muted-foreground shadow-sm md:bottom-3"
      >
        Çerez tercihleri
      </button>
    );

  return (
    <div
      ref={ref}
      data-testid="cookie-banner"
      style={{
        zIndex: 48,
        bottom: "calc(var(--mobile-bottom-nav-height) + env(safe-area-inset-bottom))",
      }}
      className="fixed left-0 right-0 border-t border-border bg-card px-3 py-2 shadow-[0_-4px_16px_rgba(0,0,0,0.06)] md:bottom-0 md:px-5 md:py-3"
    >
      <div className="mx-auto flex max-w-5xl items-center gap-3">
        <p className="min-w-0 flex-1 text-[11px] leading-snug text-muted-foreground md:text-sm">
          Analitik çerezler yalnızca onayınızla kullanılır.{" "}
          <button
            type="button"
            data-testid="cookie-details-toggle"
            onClick={() => setDetails((d) => !d)}
            className="font-semibold text-primary underline"
          >
            Seçenekler
          </button>
        </p>
        <button
          data-testid="cookie-accept-all"
          onClick={() => decide({ necessary: true, analytics: true, marketing: true })}
          className="h-10 shrink-0 rounded-full bg-primary px-5 text-sm font-bold text-primary-foreground"
        >
          Kabul et
        </button>
      </div>

      {details && (
        <div className="mx-auto mt-2 flex max-w-5xl flex-wrap items-center gap-2" data-testid="cookie-details">
          <button
            data-testid="cookie-accept-analytics"
            onClick={() => decide({ necessary: true, analytics: true, marketing: false })}
            className="h-9 rounded-full bg-secondary px-4 text-xs font-bold text-secondary-foreground"
          >
            Yalnız analitik
          </button>
          <button
            data-testid="cookie-reject"
            onClick={() => decide({ necessary: true, analytics: false, marketing: false })}
            className="h-9 rounded-full bg-muted px-4 text-xs font-bold text-primary"
          >
            Yalnız zorunlu
          </button>
          <Link to="/sayfa/cerez-politikasi" className="text-xs font-semibold text-primary underline">
            Çerez Politikası
          </Link>
        </div>
      )}
    </div>
  );
};
